// components/LeaveLayout.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LeaveTabs from './LeaveTabs';
import AddLeave from '../pages/LeaveNew/addleave';
import LeaveBalance from '../pages/LeaveNew/LeaveBalance';

const LeaveLayout = () => {
  return (
    <>
      <LeaveTabs />
      <div className="leave-content-area">
        <Routes>
          <Route index element={<AddLeave />} />
          <Route path="/add-leave" element={<AddLeave />} />
          <Route path="/addleave" element={<AddLeave />} />
          <Route path="/leave-balance" element={<LeaveBalance />} />
        </Routes>
      </div>
    </>
  );
};

export default LeaveLayout;